module.exports = "<div class=\"header-container\">\n  <div class=\"logo-containter\">\n    <div class=\"logo text-center\">\n      <img src=\"assets/images/logo.png\" style=\"width: 70px;\" />\n    </div>\n  </div>\n</div>\n\n<nb-actions size=\"medium\" class=\"header-container right\" [class.right]=\"position === 'normal'\" [class.left]=\"position === 'inverse'\">\n</nb-actions>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/minha-at3-cliente/src/app/@theme/components/header-clear/header-clear.component.html
// module id = ../../../../../src/app/@theme/components/header-clear/header-clear.component.html
// module chunks = main